import React, { type FC, useCallback, useRef, memo, useEffect } from "react";
import clsx from "clsx";
import Item from "../item/Item";

import { getUniqueGradeBodyTypeId } from "../../../../../../../common-deprecated/features/apheleia/utils/aphUtils";
import styles from "./Slider.module.scss";
import Container from "../../../../../shared-components/css-modules/lexus/atoms/Container";
import { trackBrowseGrades } from "../../../../utils/tracking";
import { useSlider } from "../../../../../../../common-deprecated/features/apheleia/hooks/useSlider";
import { useFilteredGradeBodyTypes } from "../../../../utils/filterHooks";
import Filter from "../actions/filter/Filter";
import SliderButtons from "./SliderButtons";
import ActiveFilters from "../actions/filter/ActiveFilters";
import Legend from "./legend/Legend";
import { useGradeSelectorSelector } from "../../../../redux/hooks";
import NoResults from "./noResults/NoResults";

const Slider: FC = () => {
    const wrapperRef = useRef<HTMLDivElement | null>(null);
    const anyItemRef = useRef<HTMLDivElement | null>(null);
    const sortFilter = useGradeSelectorSelector((state) => state.gradeSelectorFilters.filters.sort);
    const allGradeBodyTypes = useGradeSelectorSelector((state) => state.gradeSelectorModel.model.gradeBodyTypes);
    const gradeBodyTypes = useFilteredGradeBodyTypes();

    const trackBrowse = useCallback(() => {
        trackBrowseGrades();
    }, []);

    const { navigate, prevButtonDisabled, nextButtonDisabled, elementProps, isDragging, scrollable } = useSlider(
        wrapperRef,
        anyItemRef,
        trackBrowse,
        trackBrowse,
        gradeBodyTypes.length,
    );

    useEffect(() => {
        if (wrapperRef.current) {
            wrapperRef.current.scrollTo({ left: 0, behavior: "instant" });
        }
    }, [sortFilter]);

    return (
        <>
            {allGradeBodyTypes.length > 1 && (
                <>
                    <Container>
                        <div className={styles.navigation}>
                            <Filter />
                            <SliderButtons
                                amount={gradeBodyTypes.length}
                                navigate={navigate}
                                nextButtonDisabled={nextButtonDisabled}
                                prevButtonDisabled={prevButtonDisabled}
                                scrollable={scrollable}
                            />
                        </div>
                    </Container>
                    <ActiveFilters />
                </>
            )}

            {gradeBodyTypes.length === 0 ? (
                <NoResults />
            ) : (
                <>
                    <div
                        id="gs-slider"
                        className={clsx(styles.panel, isDragging && styles.dragging)}
                        ref={wrapperRef}
                        {...elementProps}
                    >
                        {gradeBodyTypes.map((gradeBodyType, index) => (
                            <Item
                                key={getUniqueGradeBodyTypeId(
                                    gradeBodyType.grade.id,
                                    gradeBodyType.bodyType.id,
                                    gradeBodyType.submodel?.id,
                                )}
                                ref={index === 0 ? anyItemRef : undefined}
                                gradeBodyType={gradeBodyType}
                            />
                        ))}
                    </div>
                    <div className={styles["mobile-slider-buttons"]}>
                        <SliderButtons
                            amount={gradeBodyTypes.length}
                            navigate={navigate}
                            nextButtonDisabled={nextButtonDisabled}
                            prevButtonDisabled={prevButtonDisabled}
                            scrollable={scrollable}
                        />
                    </div>

                    <Legend />
                </>
            )}
        </>
    );
};

export default memo(Slider);
